<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="mb-3">
      Step 4: General Contractor Information
    </h2>
    <form @submit.prevent="passes(stepFourNextPage)">
      <d-field label="Contractor Company Name" rules="required">
        <d-input v-model="contractorName" aria-label="Company name" rules="required" />
      </d-field>

      <div class="flex flex-wrap -mx-5">
        <d-field label="Contractor Contact First Name" rules="required" class="px-5 w-full md:w-1/2">
          <d-input v-model="contractorFirstName" aria-label="Contractor contact first name" />
        </d-field>
        <d-field label="Contractor Contact Last Name" rules="required" class="px-5 w-full md:w-1/2">
          <d-input v-model="contractorLastName" aria-label="Contractor contact last name" />
        </d-field>
      </div>

      <div class="flex flex-wrap -mx-5">
        <d-field label="Contractor Email" rules="required|email" class="px-5 w-full md:w-1/3">
          <d-input v-model="contractorEmail" type="email" aria-label="Contractor email" />
        </d-field>
        <d-field label="Contractor Phone Number" rules="required" class="px-5 w-full md:w-1/3">
          <d-input v-model="contractorPhone" aria-label="Contractor Phone Number" />
        </d-field>
        <d-field label="Contractor Fax" class="px-5 w-full md:w-1/3">
          <d-input v-model="contractorFax" aria-label="contractor Fax number" />
        </d-field>
      </div>

      <div class="flex flex-wrap -mx-5">
        <d-field label="Address Line 1" rules="required" class="px-5 w-full md:w-2/3">
          <d-input v-model="contractorAddressLine1" aria-label="Address Line 1" />
        </d-field>
        <d-field label="Address Line 2" class="px-5 w-full md:w-1/3">
          <d-input v-model="contractorAddressLine2" aria-label="Address Line 2" />
        </d-field>
        <d-field label="City" rules="required" class="px-5 w-full md:w-4/12">
          <d-input v-model="contractorCity" aria-label="City" />
        </d-field>
        <d-field label="Country" rules="required" class="px-5 w-full md:w-3/12">
          <d-select v-model="contractorCountry" expanded required>
            <option value="" disabled>
              Select a Country
            </option>
            <option v-for="country in countryOptions" :key="country.name" :value="country.name">
              {{ country.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="State/Province" rules="required" class="px-5 w-full md:w-2/12">
          <d-select v-model="contractorStateProvince" expanded required>
            <option value="" disabled>
              Select a State
            </option>
            <option v-for="state in availableStateOptions" :key="state.name" :value="state.abbreviation">
              {{ state.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="Zip/Postal" rules="required" class="px-5 w-full md:w-3/12">
          <d-input v-model="contractorZip" aria-label="Zip code" />
        </d-field>
      </div>

      <d-field>
        <d-switch v-model="sendCredentialsToContractor">
          Send QCP participant credentials to Contractor?
        </d-switch>
      </d-field>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0" :loading="submitting">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_REGISTRATION_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions, mapGetters } = createNamespacedHelpers('projectRegistrationForm');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['contractorName', 'contractorFirstName', 'contractorLastName', 'contractorEmail', 'contractorAddressLine1', 'contractorAddressLine2', 'contractorCity', 'contractorCountry', 'contractorStateProvince', 'contractorZip', 'contractorPhone', 'contractorFax', 'sendCredentialsToContractor'],
        module: 'projectRegistrationForm',
        base: 'formFields',
        mutation: PROJECT_REGISTRATION_FORM.FORM_FIELDS,
      }),

      ...mapGetters([
        'submitting',
        'countryOptions',
        'stateProvinceOptions',
      ]),

      availableStateOptions() {
        return this.stateProvinceOptions(this.contractorCountry);
      },
    },

    watch: {
      contractorCountry() {
        this.contractorStateProvince = '';
      },
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'stepFourNextPage',
      ]),
    },
  };
</script>